module.exports = __webpack_public_path__ + "img/hr-dead-dry-hairy-tree-00.d62b0af2.png";